import { mapGetters } from "vuex"

var user = {
  computed: {
    ...mapGetters(['user']),
  }
}

export default user
